import {
    Button,
    Card,
    CardBanner,
    CardBody,
    CardFooter,
    Flex,
    Separator,
    SpotIllustration,
} from '@george-labs.com/design-system';
import type { ComponentProps, FC } from 'react';
import { useEffect } from 'react';

import { t } from '@luna/i18n';
import type { BankMessage } from '@shared/bank-messages-utils';
import { BankMessageContent } from '@shared/bank-messages-utils';

import {
    trackDownloadAttachment,
    trackShowMustReadMessage,
} from './MustReadMessagesTrackingService';
import { getMustReadMessageIllustration } from './MustReadMessageService';

interface Props {
    message: BankMessage;
    onMessageAcknowledge(messageId: string): void;
    color: ComponentProps<typeof CardBanner>['color'];
}

export const MustReadMessage: FC<Props> = ({ message, onMessageAcknowledge, color }) => {
    useEffect(() => {
        trackShowMustReadMessage(message.id);
    }, []);

    return (
        <Card data-cy={`must-read-message-${message.id}`} nested>
            <CardBanner color={color}>
                <Flex justify="center" className="p-4">
                    <SpotIllustration illustration={getMustReadMessageIllustration(message.type)} />
                </Flex>
            </CardBanner>
            <CardBody>
                <BankMessageContent
                    message={message}
                    onAttachmentDownload={trackDownloadAttachment}
                />
            </CardBody>
            <Separator />
            <CardFooter>
                <Button
                    variant={Button.VARIANT.PRIMARY}
                    data-cy="acknowledge-message-option"
                    onClick={() => onMessageAcknowledge(message.id)}
                >
                    {t('mustReadMessages.acknowledgeMessage')}
                </Button>
            </CardFooter>
        </Card>
    );
};
